import React, { createContext, useState, useContext, useCallback } from 'react'

export const UserContext = createContext({})

export const UserProvider = (props) => {
    const [state, setState] = useState({
        user: null,
        UserName: null,
    })

    /**
     * Updates the user in context
     * @param {Object} user - User object with permissions
     */
    const setUser = useCallback((user) => {
        setState((prev) => ({
            ...prev,
            user,
            UserName: `${user.firstName} ${user.lastName}`,
        }))
    }, [])

    return <UserContext.Provider value={{ state, setState, setUser }}>{props.children}</UserContext.Provider>
}

/**
 * Hook to access the current user from context
 * @returns {Object|null} Current user or null if not authenticated
 */
export const useConnectedUser = () => {
    const { state } = useContext(UserContext)
    return state.user
}
